module.exports = __webpack_public_path__ + "img/icon-highlightings-2.42ec4b00.svg";